import $ from 'jquery';
import BaseTrackingView from '../../core/baseTrackingView';
import { getStorage } from '../../../home24/helpers/storage-factory';

export default BaseTrackingView.extend({

    events: {
        'click [data-helparea]': 'onHelpareaClick'
    },

    cookieCallbacks: {
        GtmContactRequest: 'afterContactRequest',
        GtmHelpareaEnter: 'afterHelpareaEnter'
    },

    onHelpareaClick: function (event) {
        getStorage().set('GtmHelpareaEnter', $(event.currentTarget).data('helparea'));
    },

    afterContactRequest: function (sValue) {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                eventCategory: 'Customer Service',
                eventAction: 'Contact Request',
                eventLabel: sValue,
                event: 'Help'
            });
        }
    },

    afterHelpareaEnter: function (sValue) {
        if (typeof window.dataLayer !== 'undefined') {

            var event = {
                eventCategory: 'Customer Service',
                event: 'Help'
            };

            switch (sValue) {

                case 'Header':
                    event.eventAction = 'Header';
                    event.eventLabel = 'Customer Service';
                    break;

                case 'Widget':
                    event.eventAction = 'Widget';
                    event.eventLabel = 'Help Area';
                    break;

                case 'FAQ':
                    event.eventAction = 'Footer';
                    event.eventLabel = 'FAQ';
                    break;

                case 'Contact':
                    event.eventAction = 'Footer';
                    event.eventLabel = 'Contact';
                    break;

                default:
                    /*
                    When any other value was there, quit this method
                     */
                    return;
            }

            window.dataLayer.push(event);
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/HelpareaEvents.js
 **/